import { render, staticRenderFns } from "./help_detail.vue?vue&type=template&id=7cd84d09&scoped=true"
import script from "./help_detail.vue?vue&type=script&lang=js"
export * from "./help_detail.vue?vue&type=script&lang=js"
import style0 from "./help_detail.vue?vue&type=style&index=0&id=7cd84d09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd84d09",
  null
  
)

export default component.exports